<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="1000"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Edit Pages</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>

      <div
        v-if="$store.getters.getSUBSCRIPTIONPLANSAllPages.length"
        class="modal-body d-flex flex-column scroll-y mx-5 py-7 d-flex flex-wrap poppins"
      >
        <div class="w-100 d-flex flex-row flex-wrap justify-content-between">
          <NestedDataTable :tableName="'pages'" />
          <!--            :handleLocationSelect="handleLocationSelect"-->
        </div>
        <!--begin::Actions-->
        <div class="mb-4 h-75px d-flex flex-grow-1 align-end justify-center">
          <!--          <button-->
          <!--            type="reset"-->
          <!--            class="btn btn-light mr-3 px-5 py-3 ls1"-->
          <!--            @click="resetFormData"-->
          <!--          >-->
          <!--            Clear-->
          <!--          </button>-->
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import NestedDataTable from "@/own/components/orderManagement/subscriptionPlans/NestedDatatable.vue";
import ApiService from "@/core/services/api.service";
import {
  // CHUTES_SET_SELECTED_LOCATION_INDEX,
  SUB_PLAN_SET_PAGES,
} from "@/core/services/store/subscriptionPlans.module";
import { SET_ITEM_FOR_ACTION } from "@/core/services/store/main.module";
import swalEdited from "@/core/services/AlertServices/SwalEdited";

export default {
  name: "EditItem",
  components: { NestedDataTable },
  props: ["refresher", "pageLoader"],
  data: () => ({
    dialog: false,
  }),
  methods: {
    toggleModal() {
      // if (!this.dialog) {
      //   this.loadDataFromServer();
      // } else
      this.dialog = !this.dialog;
    },
    loadDataFromServer(id) {
      this.$store.commit(SET_ITEM_FOR_ACTION, id);
      this.pageLoader(true);
      ApiService.post("/order_management/subscription_plans/edit_pages", { id })
        .then(({ data }) => {
          // console.log("data", data);
          this.$store.commit(SUB_PLAN_SET_PAGES, {
            pages: data.subscription_plan_pages,
            all_pages: data.all_pages,
          });

          this.pageLoader(false);
          this.dialog = true;
        })
        .catch(() => {
          this.dialog = false;
          this.pageLoader(false);
        });
    },

    // toggleNextButton(id, event, tableName) {
    //   let elem;
    //   if (event.target.firstElementChild) elem = event.target;
    //   else elem = event.target.parentElement.parentElement;
    //
    //   elem.classList.add("bg-light-info");
    //   elem.firstElementChild.firstElementChild.style.color = "#8950fc";
    //
    //   const rows = document.querySelectorAll(
    //     `.${tableName}-tb > .list-container  > tr > td.d-flex .bg-light-info`
    //   );
    //   rows.forEach((element) => {
    //     if (!element.classList.contains(`${tableName}-tb-${id}-next-btn`)) {
    //       element.classList.remove("bg-light-info");
    //       element.firstElementChild.firstElementChild.style.color =
    //         "rgba(0, 0, 0, 0.54)";
    //     }
    //   });
    //
    //   this.$store.commit(SET_PAGE_LOADING, false);
    // },
    // handleLocationSelect(selectedLocationId, event) {
    //   this.$store.commit(SET_PAGE_LOADING, true);
    //
    //   const location_index =
    //     this.$store.getters.getWESCONFIGCHUTESMappings.findIndex(
    //       (location) => location.id === selectedLocationId
    //     );
    //
    //   // this.$store.commit(CHUTES_SET_SELECTED_LOCATION_INDEX, location_index);
    //
    //   if (location_index > -1) {
    //     this.$store.getters.getSUBSCRIPTIONPLANSPages.forEach((category) => {
    //       category.is_selected = Boolean(
    //         this.$store.getters.getWESCONFIGCHUTESMappings[
    //           location_index
    //         ].categories.find((item) => item === category.index)
    //       );
    //     });
    //   }
    //   this.toggleNextButton(selectedLocationId, event, "locations");
    // },
    submitForm() {
      this.pageLoader(true);

      const payload = {
        subscription_plan_id: this.$store.getters.getItemForAction,
        subscription_plan_pages:
          this.$store.getters.getSUBSCRIPTIONPLANSPages.map((page) => ({
            ...page,
          })),
      };
      // console.log(payload);
      // return;

      ApiService.post(
        `/order_management/subscription_plans/update_pages`,
        payload
      )
        .then(() => {
          swalEdited();
          this.refresher();
          this.dialog = false;
        })
        .finally(() => {
          this.pageLoader(false);
        });
    },
  },
};
</script>
